module.exports = __webpack_public_path__ + "img/西瓜1.7eae28e4.png";